import React from 'react';
import { PropTypes } from 'prop-types';
// components
import MainMenuOverlay from 'refactored/ui/nav/mainMenu/MainMenuOverlay';
import MainMenuBar from 'refactored/ui/nav/mainMenu/MainMenuBar';

const MainMenu = ({ handleBack, isMainMenuOpened }) => (
  <>
    <MainMenuBar isCollapsed={!isMainMenuOpened} handleBack={handleBack} />
    <MainMenuOverlay isVisible={isMainMenuOpened} />
  </>
);

MainMenu.propTypes = {
  handleBack: PropTypes.func,
  isMainMenuOpened: PropTypes.bool,
};

export default MainMenu;
